import React, { useEffect, useState, useContext } from 'react';
import { LMDrawingContext, LMShowEllipseContext } from '../contexts/AppContext';
import { SetupColors, LMList } from '../utils/LMConstants';

function LMDisplaySelector({currentSession}){

    const [currentLMs, SetCurrentLMs] = useState([]);

    const { lmDrawing, setLMDrawing }= useContext(LMDrawingContext);
    const { LMShowEllipse, setLMShowEllipse } = useContext(LMShowEllipseContext);

    useEffect(() => {
        getUniqueLMs(currentSession);

      }, [currentSession]);

    const handleDrawEllipse = (e) =>{
        setLMShowEllipse(e.target.checked);
    };

    function getUniqueLMs(data){
        const uniqueLMTypes = new Set();

        if(!data){
            setLMDrawing([]);
            return;
        }

        if(!data.SessionSetups){
            setLMDrawing([]);
            return;
        }

        data.SessionSetups.forEach(sessionSetup => {
            // Iterate through the Shots in each SessionSetup
            if(sessionSetup.Shots){
                sessionSetup.Shots.forEach(shot => {
                    // Iterate through the LMInfos in each Shot
                    shot.LMInfos.forEach(lmInfo => {
                        // Add the LMType to the set
                        const lmData = LMList.find(lm => lm.type === lmInfo.LMType);
    
                        if(lmData.hasTraj && lmData.hasTraj){
                            uniqueLMTypes.add(lmInfo.LMType);
                        }
                    });
                });
            }
        });

        const lms = Array.from(uniqueLMTypes);
        if(lms.length > 0){
            setLMDrawing(prev => (prev && lms.includes(prev) ? prev : lms[0] ?? []));
        }
        SetCurrentLMs(lms);
    }

    const handleLMChange = (e) => {
        setLMDrawing(e.target.id);
    }

    return(
        <div style={{width:'100%', height:'100%'}}>
            <div className='desktop-left-container-lmdisplay-inner'>
                <div className='desktop-left-container-lmdisplay-ellipse'>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox" name='ellipseCheckbox' style={{width:'25px', height:'25px'}} onChange={handleDrawEllipse} checked={LMShowEllipse}/>
                        <label htmlFor='ellipseCheckbox' style={{marginLeft:'5px'}}>Show Ellipses</label>
                    </div>
                </div>
                <div style={{padding: '5px'}}>Displayed Launch Monitors</div>
                {currentLMs.map((item,index) => (
                    <div key={index} style={{display: 'flex', alignItems: 'center', width: '100%', background: LMList.find(l => l.type === item).color, padding: '5px'}}>
                        <input type="radio" id={item} name="LM" value={item} onChange={handleLMChange} checked={lmDrawing === item} style={{width:'20px', height:'20px'}}/>
                        <label htmlFor={item} style={{marginLeft:'5px', color:'black', fontWeight:'bold'}}>{item}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LMDisplaySelector;